// extracted by mini-css-extract-plugin
module.exports = {"message":"T9UZi","text":"tK8l2","checkbox":"m+B3Q","wrapperActions":"vHipN","wrapperButton":"QuEFg","submitButton":"C+giH"};